const routes = [
    {
        path: '/assinatura_digital/integracoes/index',
        component: () => import('../views/IntegracaoLoja')
    },
    {
        path: '/assinatura_digital/integracao_api',
        component: () => import('../views/IntegracaoApi/index.vue')
    },
    {
        // Chaves de API da empresa (mesma tela do módulo integracao_api); o token único de antes
        // (FormularioToken) foi substituído em 2026-09-07
        path: '/assinatura_digital/integracao_api/credenciais',
        alias: ['/assinatura_digital/integracao_api/configuracao_token'],
        component: () => import('../views/IntegracaoApi/Credenciais.vue')
    },
    {
        // Documentação OpenAPI gerada pelo backend (só o módulo assinatura_digital); o Apiary
        // embutido foi aposentado em 2026-09-07.
        meta: { fullScreen: true },
        path: '/assinatura_digital/integracao_api/documentacao',
        component: () => import('../views/IntegracaoApi/Documentacao.vue')
    }
]
export default routes
  